import welcome from '../assets/welcome.jpg'
import fork from '../assets/fork.png'
import forkandknife from '../assets/forkandKnife.png'
import A from '../assets/A.png'
import G from '../assets/G.png'
import spoon from '../assets/spoon.png'
import menu from '../assets/menu.jpg'
import chef from '../assets/chef.jpg'
import quote from '../assets/quote.png'
import sign from '../assets/signature.png'
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import laurels from '../assets/laurels.png'
import findus from '../assets/findus.jpg'

export default{
    welcome,
    fork,
    forkandknife,
    A,
    G,
    spoon,
    menu,
    chef,
    quote,
    sign,
    award01,
    award02,
    award03,
    award05,
    laurels,
    findus,
}